/* In-cart upsell - Shopify native recommendations (self-healing).
   Tries complementary products (curated in Search & Discovery);
   falls back to automatic related products. Renders into
   #cart-upsell in the cart drawer. A MutationObserver re-renders
   whenever the drawer opens or its contents change, so the upsell
   appears reliably even on a fresh cart / after AJAX re-renders. */
(function () {
  'use strict';
  var LIMIT = 8;
  var fetching = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getContainer() {
    return document.getElementById('cart-upsell');
  }

  function buildUrl(intent, seed) {
    return root() + 'recommendations/products?section_id=cart-recommendations&intent=' + intent + '&limit=' + LIMIT + '&product_id=' + encodeURIComponent(seed);
  }

  function inject(text) {
    var current = getContainer();
    if (!current) return false;
    var slot = current.querySelector('.cart-upsell__slot');
    if (!slot) return false;
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var heading = doc.querySelector('.cart-upsell__heading');
    var list = doc.querySelector('.cart-upsell__list');
    var hasCards = list && list.querySelector('.cart-upsell__card');
    slot.innerHTML = '';
    if (hasCards) {
      if (heading) slot.appendChild(heading);
      slot.appendChild(list);
      current.hidden = false;
      return true;
    }
    current.hidden = true;
    return false;
  }

  function render(force) {
    var container = getContainer();
    if (!container) return;
    var seed = container.getAttribute('data-seed');
    if (!seed) { container.hidden = true; return; }
    if (!force && container.getAttribute('data-loaded') === seed) return;
    if (fetching) return;
    fetching = true;
    container.setAttribute('data-loaded', seed);
    fetch(buildUrl('complementary', seed))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        if (inject(text)) { fetching = false; return null; }
        var c = getContainer();
        var seed2 = c ? c.getAttribute('data-seed') : seed;
        return fetch(buildUrl('related', seed2))
          .then(function (r) { return r.text(); })
          .then(function (t2) { inject(t2); fetching = false; });
      })
      .catch(function () { fetching = false; });
  }

  function addToCart(variantId, button) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {}
    }
    var original = button ? button.textContent : '';
    if (button) { button.setAttribute('disabled', ''); button.textContent = 'Adding...'; }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (!parsed || parsed.status) {
          if (button) { button.removeAttribute('disabled'); button.textContent = original || 'Add'; }
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsed.sections) {
          cartDrawer.renderContents(parsed);
        }
        setTimeout(function () { render(true); }, 80);
      })
      .catch(function () {
        if (button) { button.removeAttribute('disabled'); button.textContent = original || 'Add'; }
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.cart-upsell__add[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (id) addToCart(id, btn);
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(function () { render(true); }, 80); });
  }

  function observeDrawer() {
    var drawer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    var timer;
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { render(false); }, 150);
    });
    obs.observe(drawer, { childList: true, subtree: true });
    var dd = document.querySelector('cart-drawer');
    if (dd) {
      var obs2 = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { render(false); }, 150);
      });
      obs2.observe(dd, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    render(false);
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
